import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { compartilharTexto } from "@/lib/whatsapp";
import api, { brl } from "@/lib/api";
import { useRecurso, MSG_SEM_RECURSO } from "@/lib/recursos";
import { Button } from "@/components/ui/button";
import { MapPin, Loader2, Navigation, Share2, Route } from "lucide-react";
import { toast } from "sonner";

export default function RotaCobranca() {
  const temRota = useRecurso("rota_cobranca");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/collection/route").then(({ data }) => { setItems(data); setLoading(false); });
  }, []);

  const total = items.reduce((s, x) => s + Number(x.total || 0), 0);

  const maps = (endereco) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`;
  const routeAll = () => {
    const stops = items.filter((x) => x.endereco && x.endereco !== "Endereço não informado").map((x) => encodeURIComponent(x.endereco));
    if (!stops.length) return;
    const dest = stops[stops.length - 1];
    const waypoints = stops.slice(0, -1).join("|");
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${dest}${waypoints ? `&waypoints=${waypoints}` : ""}&travelmode=driving`, "_blank");
  };
  const whats = async (x) => {
    try {
      const { data } = await api.get(`/cobranca/texto-cliente/${x.cliente_id}`);
      await compartilharTexto({ texto: data.texto, titulo: "Cobrança", cliente_id: x.cliente_id, telefone: data.telefone, evento: "cobranca_rota", categoria: "Cobrança" });
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao gerar cobrança"); }
  };

  return (
    <div className="space-y-5 fade-up" data-testid="rota-page">
      {!temRota && <div className="rounded-lg border border-amber-300 bg-amber-50 text-amber-900 text-sm px-3 py-2" data-testid="sem-recurso-rota">{MSG_SEM_RECURSO}</div>}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><h1 className="text-2xl font-extrabold tracking-tight">Rota de Cobrança</h1><p className="text-slate-500 text-sm">Clientes em atraso para visita hoje.</p></div>
        <Button onClick={routeAll} disabled={!items.length} className="bg-onyx hover:bg-black text-white gap-2" data-testid="rota-open-maps"><Route className="w-4 h-4" /> Abrir rota no mapa</Button>
      </div>

      <div className="bg-onyx rounded-xl p-5 gold-border flex items-center justify-between">
        <div><div className="text-slate-400 text-xs uppercase tracking-wider">Total em atraso na rota</div>
          <div className="text-white text-2xl font-extrabold mono mt-1" data-testid="rota-total">{brl(total)}</div></div>
        <div className="text-right"><div className="text-slate-400 text-xs uppercase tracking-wider">Clientes</div>
          <div className="text-white text-2xl font-extrabold mt-1">{items.length}</div></div>
      </div>

      {loading ? <div className="py-10 text-center"><Loader2 className="w-6 h-6 animate-spin gold-text mx-auto" /></div>
        : items.length === 0 ? <div className="trt-card p-10 text-center text-slate-400">Nenhum cliente em atraso. 🎉</div>
        : <div className="space-y-3">
            {items.map((x, i) => (
              <div key={x.cliente_id} className="trt-card p-4" data-testid={`rota-item-${x.cliente_id}`}>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-full bg-onyx text-gold font-bold flex items-center justify-center shrink-0">{i + 1}</div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold cursor-pointer hover:underline" onClick={() => navigate(`/clientes/${x.cliente_id}`)}>{x.cliente_nome}</div>
                    <div className="text-sm text-slate-500 flex items-center gap-1 mt-0.5"><MapPin className="w-3.5 h-3.5" /> {x.endereco}</div>
                    <div className="text-xs text-slate-400 mt-0.5">{x.parcelas} parcela(s) em atraso</div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="font-bold text-red-600 mono">{brl(x.total)}</div>
                  </div>
                </div>
                <div className="flex gap-2 mt-3">
                  <a href={maps(x.endereco)} target="_blank" rel="noreferrer" className="flex-1">
                    <Button size="sm" variant="outline" className="w-full gap-1" data-testid={`rota-maps-${x.cliente_id}`}><Navigation className="w-4 h-4" /> Mapa</Button>
                  </a>
                  <Button size="sm" variant="outline" onClick={() => whats(x)} className="flex-1 gap-1 text-emerald-600 border-emerald-200 hover:bg-emerald-50" data-testid={`rota-share-${x.cliente_id}`}><Share2 className="w-4 h-4" /> Cobrança</Button>
                </div>
              </div>
            ))}
          </div>}
    </div>
  );
}
